// Centralized funnel event names so we can analyze drop-off in PostHog/Mixpanel.
// Use a single prefix `funnel_` so they cluster in dashboards.
import { trackEvent } from '../services/analytics';

export const FUNNEL = {
  HERO_VIEW:                     'funnel_hero_view',
  HERO_FORM_SUBMITTED:           'funnel_hero_form_submitted',
  HERO_BUY_CTA_CLICKED:          'funnel_hero_buy_cta_clicked',
  AUTH_MODAL_SHOWN:              'funnel_auth_modal_shown',
  AUTH_STARTED:                  'funnel_auth_started',
  AUTH_COMPLETED:                'funnel_auth_completed',
  PROJECT_CREATION_OPENED:       'funnel_project_creation_opened',
  FEATURES_EXTRACTION_STARTED:   'funnel_features_extraction_started',
  FEATURES_EXTRACTION_COMPLETED: 'funnel_features_extraction_completed',
  FEATURES_SELECTED:             'funnel_features_selected',
  PRD_GENERATION_STARTED:        'funnel_prd_generation_started',
  PRD_GENERATION_COMPLETED:      'funnel_prd_generation_completed',
  PRD_GENERATION_FAILED:         'funnel_prd_generation_failed',
  PAYWALL_SHOWN:                 'funnel_paywall_shown',
  PLAN_SELECTED:                 'funnel_plan_selected',
  STRIPE_REDIRECT:               'funnel_stripe_redirect',
  STRIPE_RETURNED:               'funnel_stripe_returned',
  PAYMENT_VERIFIED:              'funnel_payment_verified',
  TRIAL_CONSUMED:                'funnel_trial_consumed',
  DASHBOARD_LANDED:              'funnel_dashboard_landed',
};

export function trackFunnel(event, props = {}) {
  trackEvent(event, { ...props, source: 'main_funnel' });
}
